import {
    MMSI_NO_VERIFICATION,
    OTHER_DETAILS,
    SHIP_OWNERS_PARTICULARS,
    STATION_INFORMATION,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/SSLApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatSSLApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'ship-station',
        formID: 'ship-station',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${SHIP_OWNERS_PARTICULARS}-date-of-birth`]: formatDateTo_ddMMyyyy(licenceDetails?.shipOwnerParticulars?.dateOfBirth) ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-place-of-birth`]: licenceDetails?.shipOwnerParticulars?.placeOfBirth ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-nationality`]: licenceDetails?.shipOwnerParticulars?.nationality ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-residential-status`]: licenceDetails?.shipOwnerParticulars?.residentialStatus ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-sex`]: licenceDetails?.shipOwnerParticulars?.Sex ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`]: licenceDetails?.shipOwnerParticulars?.isThereACoOwner ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-nric-fin`]: licenceDetails?.CoOwnerParticulars?.nricFin ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-co-owners-name`]: licenceDetails?.CoOwnerParticulars?.coOwnerSName ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-co-owners-date-of-birth`]:
                formatDateTo_ddMMyyyy(licenceDetails?.CoOwnerParticulars?.coOwnerSDateOfBirth) ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-co-owners-place-of-birth`]: licenceDetails?.CoOwnerParticulars?.coOwnerSPlaceOfBirth ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-co-owners-nationality`]: licenceDetails?.CoOwnerParticulars?.coOwnerSNationality ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-co-owners-residential-status`]: licenceDetails?.CoOwnerParticulars?.residentialStatus ?? '-',
            [`${SHIP_OWNERS_PARTICULARS}-co-owners-sex`]: licenceDetails?.CoOwnerParticulars?.coOwnerSSex ?? '-',

            [`${MMSI_NO_VERIFICATION}-call-sign`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.callSign ?? '-',
            [`${MMSI_NO_VERIFICATION}-telex-over-radio-no`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.telexOverRadioTorNo ?? '-',
            [`${MMSI_NO_VERIFICATION}-mmsi-no`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.mmsiNoDscSsiEpirb ?? '-',
            [`${MMSI_NO_VERIFICATION}-mmsi-expiry-date`]:
                formatDateTo_ddMMyyyy(licenceDetails?.mmsiNoDscSsiEpirbVerification?.mmsiExpiryDate) ?? '-',

            [`${STATION_INFORMATION}-vessel-name`]: licenceDetails?.stationInformation?.vesselName ?? '-',
            [`${STATION_INFORMATION}-area-of-operation`]: licenceDetails?.stationInformation?.areaOfOperation ?? '-',
            [`${STATION_INFORMATION}-vessel-gross-tonnage`]: licenceDetails?.stationInformation?.vesselGrossTonnage ?? '-',
            [`${STATION_INFORMATION}-month-year-built`]: licenceDetails?.stationInformation?.monthYearBuilt ?? '-',
            [`${STATION_INFORMATION}-itu-nature-of-service`]: licenceDetails?.stationInformation?.ituNatureOfService ?? '-',
            [`${STATION_INFORMATION}-accounting-authority`]: licenceDetails?.stationInformation?.accountingAuthority ?? '-',
            [`${STATION_INFORMATION}-station-information-remarks`]: licenceDetails?.stationInformation?.remarks ?? '-',
            [`${STATION_INFORMATION}-inmarsat-id-c`]: licenceDetails?.stationInformation?.inmarsatIdC ?? '-',
            [`${STATION_INFORMATION}-other-id-line-1`]: licenceDetails?.stationInformation?.otherIdLine1 ?? '-',
            [`${STATION_INFORMATION}-other-id-line-2`]: licenceDetails?.stationInformation?.otherIdLine2 ?? '-',
            [`${STATION_INFORMATION}-other-id-line-3`]: licenceDetails?.stationInformation?.otherIdLine3 ?? '-',
            [`${STATION_INFORMATION}-other-id-line-4`]: licenceDetails?.stationInformation?.otherIdLine4 ?? '-',
            [`${STATION_INFORMATION}-official-no`]: licenceDetails?.stationInformation?.officialNo ?? '-',
            [`${STATION_INFORMATION}-vessel-type`]: licenceDetails?.stationInformation?.vesselType ?? '-',
            [`${STATION_INFORMATION}-satellite-service`]: licenceDetails?.stationInformation?.satelliteService ?? '-',
            [`${STATION_INFORMATION}-purposes`]: licenceDetails?.stationInformation?.purposes ?? '-',
            [`${STATION_INFORMATION}-brand-and-model`]: licenceDetails?.stationInformation?.brandAndModel ?? '-',
            [`${STATION_INFORMATION}-hours-of-service`]: licenceDetails?.stationInformation?.hoursOfService ?? '-',
            [`${STATION_INFORMATION}-start-time`]: licenceDetails?.stationInformation?.startTime ?? '-',
            [`${STATION_INFORMATION}-end-time`]: licenceDetails?.stationInformation?.endTime ?? '-',

            [`${OTHER_DETAILS}-proposed-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-ship-station',
            formID: 'amend-ship-station',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${SHIP_OWNERS_PARTICULARS}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                [`${SHIP_OWNERS_PARTICULARS}-date-of-birth`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.shipOwnerParticulars?.dateOfBirth) ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-place-of-birth`]: licenceDetails?.shipOwnerParticulars?.placeOfBirth ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-nationality`]: licenceDetails?.shipOwnerParticulars?.nationality ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-residential-status`]: licenceDetails?.shipOwnerParticulars?.residentialStatus ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-sex`]: licenceDetails?.shipOwnerParticulars?.Sex ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`]: licenceDetails?.shipOwnerParticulars?.isThereACoOwner ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-nric-fin`]: licenceDetails?.CoOwnerParticulars?.nricFin ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-co-owners-name`]: licenceDetails?.CoOwnerParticulars?.coOwnerSName ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-co-owners-date-of-birth`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.CoOwnerParticulars?.coOwnerSDateOfBirth) ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-co-owners-place-of-birth`]: licenceDetails?.CoOwnerParticulars?.coOwnerSPlaceOfBirth ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-co-owners-nationality`]: licenceDetails?.CoOwnerParticulars?.coOwnerSNationality ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-co-owners-residential-status`]: licenceDetails?.CoOwnerParticulars?.residentialStatus ?? '-',
                [`${SHIP_OWNERS_PARTICULARS}-co-owners-sex`]: licenceDetails?.CoOwnerParticulars?.coOwnerSSex ?? '-',

                [`${MMSI_NO_VERIFICATION}-call-sign`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.callSign ?? '-',
                [`${MMSI_NO_VERIFICATION}-telex-over-radio-no`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.telexOverRadioTorNo ?? '-',
                [`${MMSI_NO_VERIFICATION}-mmsi-no`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.mmsiNoDscSsiEpirb ?? '-',
                [`${MMSI_NO_VERIFICATION}-mmsi-expiry-date`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.mmsiNoDscSsiEpirbVerification?.mmsiExpiryDate) ?? '-',

                [`${STATION_INFORMATION}-vessel-name`]: licenceDetails?.stationInformation?.vesselName ?? '-',
                [`${STATION_INFORMATION}-area-of-operation`]: licenceDetails?.stationInformation?.areaOfOperation ?? '-',
                [`${STATION_INFORMATION}-vessel-gross-tonnage`]: licenceDetails?.stationInformation?.vesselGrossTonnage ?? '-',
                [`${STATION_INFORMATION}-month-year-built`]: licenceDetails?.stationInformation?.monthYearBuilt ?? '-',
                [`${STATION_INFORMATION}-itu-nature-of-service`]: licenceDetails?.stationInformation?.ituNatureOfService ?? '-',
                [`${STATION_INFORMATION}-accounting-authority`]: licenceDetails?.stationInformation?.accountingAuthority ?? '-',
                [`${STATION_INFORMATION}-station-information-remarks`]: licenceDetails?.stationInformation?.remarks ?? '-',
                [`${STATION_INFORMATION}-inmarsat-id-c`]: licenceDetails?.stationInformation?.inmarsatIdC ?? '-',
                [`${STATION_INFORMATION}-other-id-line-1`]: licenceDetails?.stationInformation?.otherIdLine1 ?? '-',
                [`${STATION_INFORMATION}-other-id-line-2`]: licenceDetails?.stationInformation?.otherIdLine2 ?? '-',
                [`${STATION_INFORMATION}-other-id-line-3`]: licenceDetails?.stationInformation?.otherIdLine3 ?? '-',
                [`${STATION_INFORMATION}-other-id-line-4`]: licenceDetails?.stationInformation?.otherIdLine4 ?? '-',
                [`${STATION_INFORMATION}-official-no`]: licenceDetails?.stationInformation?.officialNo ?? '-',
                [`${STATION_INFORMATION}-vessel-type`]: licenceDetails?.stationInformation?.vesselType ?? '-',
                [`${STATION_INFORMATION}-satellite-service`]: licenceDetails?.stationInformation?.satelliteService ?? '-',
                [`${STATION_INFORMATION}-purposes`]: licenceDetails?.stationInformation?.purposes ?? '-',
                [`${STATION_INFORMATION}-brand-and-model`]: licenceDetails?.stationInformation?.brandAndModel ?? '-',
                [`${STATION_INFORMATION}-hours-of-service`]: licenceDetails?.stationInformation?.hoursOfService ?? '-',
                [`${STATION_INFORMATION}-start-time`]: licenceDetails?.stationInformation?.startTime ?? '-',
                [`${STATION_INFORMATION}-end-time`]: licenceDetails?.stationInformation?.endTime ?? '-',

                [`${OTHER_DETAILS}-proposed-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',
                [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
};

const sslApplicationPayload = {
    formatSSLApplication
};

export default sslApplicationPayload;
